export const audits = {
  title: 'Nhật ký hoạt động',
  titles: {
    list: 'Nhật ký hoạt động',
  },
  fields: {
    createdAt: 'Thời gian',
    timeAndUser: 'Thời gian / NV',
    entityType: 'Bảng dữ liệu',
    entityTypeShort: 'Bảng DL',
    entityMeta: 'Bảng DL / HĐ / ID',
    action: 'Hành động',
    actionShort: 'Hoạt động',
    entityId: 'ID bản ghi',
    userName: 'Người thực hiện',
    ipAddress: 'IP',
    description: 'Mô tả',
    changeDetail: 'Mô tả / ngữ cảnh',
    changeContent: 'Nội dung sửa',
    relatedCodes: 'Mã liên quan',
    contextLabels: {
      donHang: 'ĐH',
      hoaDon: 'HĐ',
      traHang: 'TH',
      khachHang: 'KH',
      hang: 'Hàng',
      sp: 'SP',
      nhom: 'Nhóm',
      ncc: 'NCC',
      bangGia: 'BG',
      pk: 'PK',
      pn: 'PN',
      ycx: 'YCX',
      sc: 'SC',
      pt: 'PT',
      pc: 'PC',
      tkq: 'TKQ',
    },
    beforeChange: 'Trước khi sửa',
    afterChange: 'Sau khi sửa',
    requestInfo: 'Nguồn thao tác',
    duAn: 'Mảng',
    chiNhanh: 'Chi nhánh',
    nguon: 'Nguồn',
    maThietBi: 'Mã thiết bị',
    ungDung: 'Ứng dụng',
    manHinh: 'Màn hình',
    tenApi: 'Thao tác',
    hamXuLy: 'Hàm xử lý',
    device: 'Thiết bị',
    api: 'API',
  },
  nguon: {
    WEB: 'WEB',
    MOBILE: 'App mobile',
    API: 'API trực tiếp',
  },
  filter: {
    placeholder: 'Tìm mô tả, mã đơn, hóa đơn, ID…',
    advancedFilter: 'Lọc nâng cao',
    search: 'Tìm kiếm',
    ma: 'Mã (đơn / HĐ / hàng)',
    maPlaceholder: 'Mã đơn, hóa đơn, mã hàng…',
    entityType: 'Bảng dữ liệu',
    entityId: 'ID bản ghi',
    userId: 'ID người dùng',
    user: 'Người dùng',
    action: 'Hành động',
    chiNhanh: 'Chi nhánh',
    phamVi: 'Phạm vi',
    phamViHienTai: 'Mảng đang đăng nhập',
    phamViTatCa: 'Tất cả mảng',
    duAn: 'Mảng',
    nhomHanhDong: 'Nhóm hành động',
    nhomHanhDongOptions: {
      taiKhoan: 'Tài khoản (đăng nhập, mật khẩu…)',
      nghiepVu: 'Nghiệp vụ (thao tác dữ liệu)',
    },
    ipAddress: 'Địa chỉ IP',
    ipAddressPlaceholder: 'VD: 113.161',
    thietBi: 'Thiết bị / trình duyệt',
    thietBiPlaceholder: 'VD: iPhone, Samsung, Chrome, mã thiết bị',
    duongDan: 'API (đường dẫn / tên)',
    duongDanPlaceholder: 'VD: /dat-hang, Tạo hóa đơn',
    phuongThuc: 'Phương thức',
    nguonThaoTac: 'Nguồn thao tác',
    nguon: 'Nguồn',
    manHinh: 'Màn hình / trang',
    manHinhPlaceholder: 'VD: /admin/hoa-don, DonHangChiTiet',
    sortFields: {
      ngayTao: 'Thời gian',
      entityType: 'Bảng dữ liệu',
      entityId: 'ID bản ghi',
      userId: 'Người thực hiện',
      action: 'Hành động',
      id: 'ID nhật ký',
    },
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    all: 'Tất cả',
    clearFilter: 'Xóa lọc',
    apply: 'Tìm kiếm',
    clear: 'Xóa lọc',
  },
  messages: {
    noData: 'Không có dữ liệu nhật ký',
    totalLogs: 'Tổng: {total} bản ghi',
    emptyValue: 'Trống',
    noChangeDetail: 'Không ghi nhận chi tiết thay đổi',
    moreChanges: 'và {count} thay đổi khác',
    fieldChangeCount: '{count} trường thay đổi',
  },
  export: {
    button: 'Export',
    fileName: 'Nhat_ky_hoat_dong_{date}.xlsx',
    sheetName: 'Nhat ky hoat dong',
    success: 'Xuất file Excel thành công',
    failed: 'Xuất file Excel thất bại',
    loading: 'Đang xuất...',
  },
  entityTypes: {
    DMHangHoaChiNhanh: 'Hàng hóa chi nhánh',
    DMHangHoa: 'Hàng hóa',
    DMSanPham: 'Sản phẩm',
    DMNhomSanPham: 'Nhóm sản phẩm',
    DMNhomHang: 'Nhóm hàng',
    DMDonViTinh: 'Đơn vị tính',
    DMNhaCungCap: 'Nhà cung cấp',
    DMKhachHang: 'Khách hàng',
    DMNhomKhachHang: 'Nhóm khách hàng',
    DMDiaChiNhanHang: 'Địa chỉ nhận hàng',
    DMThongTinXuatHoaDon: 'Thông tin xuất hóa đơn',
    DMDoiTacGiaoHang: 'Đối tác giao hàng',
    DMNhomDoiTacGiaoHang: 'Nhóm đối tác giao hàng',
    DMDichVuGiaoHang: 'Dịch vụ giao hàng',
    HTTichHopNhaVanChuyen: 'Tích hợp nhà vận chuyển',
    DMBangGia: 'Bảng giá',
    HTCaiDatBanHang: 'Cài đặt bán hàng',
    PKCH: 'Phiếu kho chi nhánh',
    PKCT: 'Phiếu kho chi tiết',
    PNhanHPhieuNhanHang: 'Phiếu nhận hàng',
    DHHoaDon: 'Hóa đơn',
    DHDonHang: 'Đơn hàng',
    DHPhieuTraHang: 'Phiếu trả hàng',
    SCYeuCauSuaChua: 'Yêu cầu sửa chữa',
    HTNguoiDung: 'Người dùng',
    SQuyPhieuThu: 'Phiếu thu',
    SQuyPhieuChi: 'Phiếu chi',
    SQuyTaiKhoanQuy: 'Tài khoản quỹ',
    DHYeuCauXuatHoaDon: 'Yêu cầu xuất hóa đơn',
    HTMauIn: 'Mẫu in',
    CNGiaoDich: 'Giao dịch công nợ',
    CNChotCongNo: 'Chốt công nợ',
  },
  actions: {
    CREATE: 'Tạo mới',
    UPDATE: 'Cập nhật',
    DELETE: 'Xóa',
    STATUS_CHANGE: 'Đổi trạng thái',
    CREATE_PHIEU_THU: 'Tạo phiếu thu',
    UPDATE_PHIEU_THU: 'Cập nhật phiếu thu',
    SUBMIT_FOR_APPROVAL: 'Gửi duyệt phiếu',
    APPROVE_PHIEU_THU: 'Duyệt phiếu thu',
    REJECT_PHIEU_THU: 'Từ chối phiếu thu',
    CANCEL_PHIEU_THU: 'Hủy phiếu thu',
    DELETE_PHIEU_THU: 'Xóa phiếu thu nháp',
    CREATE_PHIEU_CHI: 'Tạo phiếu chi',
    UPDATE_PHIEU_CHI: 'Cập nhật phiếu chi',
    APPROVE_PHIEU_CHI: 'Duyệt phiếu chi',
    REJECT_PHIEU_CHI: 'Từ chối phiếu chi',
    CANCEL_PHIEU_CHI: 'Hủy phiếu chi',
    DELETE_PHIEU_CHI: 'Xóa phiếu chi nháp',
    CREATE_TAI_KHOAN_QUY: 'Tạo tài khoản quỹ',
    UPDATE_TAI_KHOAN_QUY: 'Cập nhật tài khoản quỹ',
    ACTIVATE_TAI_KHOAN_QUY: 'Kích hoạt tài khoản quỹ',
    DEACTIVATE_TAI_KHOAN_QUY: 'Ngừng tài khoản quỹ',
    DELETE_TAI_KHOAN_QUY: 'Xóa tài khoản quỹ',
    CREATE_YCX: 'Tạo yêu cầu xuất hóa đơn',
    GUI_KT: 'Gửi kế toán',
    GUI_KHACH: 'Gửi khách hàng',
    KHACH_DONG_Y: 'Khách đồng ý',
    KHACH_KHONG_DONG_Y: 'Khách không đồng ý',
    HOAN_THANH: 'Hoàn thành',
    HUY: 'Hủy yêu cầu',
    DANG_NHAP: 'Đăng nhập',
    DANG_NHAP_THAT_BAI: 'Đăng nhập thất bại',
    DANG_XUAT: 'Đăng xuất',
    DOI_CHI_NHANH: 'Đổi chi nhánh',
    DOI_MAT_KHAU: 'Đổi mật khẩu',
    CAP_NHAT_HO_SO: 'Cập nhật hồ sơ',
  },
}
